export default __webpack_public_path__ + "static/media/venda-avulsa-example.94b4af7a.png";